import axios from "axios";
import { getFeedbackDetails } from "@redux/actions/getFeedback-action";
import { sessionExpireTimeout } from "@redux/actions/utility-actions";
import { BASE_URL } from "../../variables";

export const addTodaysTourReportApi =  ({ RecordId, Observation }) => async(dispatch) => {
  const options = {
    url: `${BASE_URL}/services/apexrest/Edit_Feedback/`,
    method: "patch",
    data: { RecordId, Observation },
  };
  try {
    const response = await axios(options);
    if (response.status === 200) {
      dispatch(getFeedbackDetails());
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  }catch (err) {
    if (err.code === "ERR_NETWORK") {
      sessionExpireTimeout(dispatch);
    } else {
      return {
        success: false,
        msg: "Somthing Went Wrong..!!",
      };
    }
  }
};
